import type { ReactNode } from "react";

import { Text } from "@/components/ui/text";

export function TabLayout({
  children,
  title,
  description,
  actions,
}: {
  children: ReactNode;
  title?: string;
  description?: ReactNode;
  actions?: ReactNode;
}) {
  const hasHeaderComponent = title || description || actions;
  return (
    <div className="flex flex-col gap-1 mt-3 flex-1">
      {hasHeaderComponent && (
        <div className="flex items-center justify-between gap-2 mb-2 flex-wrap md:flex-nowrap">
          <div className="flex flex-col w-full">
            {title && <Text bold>{title}</Text>}
            {description ? (
              typeof description === "string" ? (
                <Text elementType="p" muted>
                  {description}
                </Text>
              ) : (
                description
              )
            ) : null}
          </div>
          {actions && (
            <div className="shrink-0 flex items-center gap-2">{actions}</div>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
